export default __webpack_public_path__ + "static/media/fa-regular-400.fcaa6c13.woff";